import { Dependencies } from "@planzone/core";
import {
  Account,
  Id,
  planzone,
  PlanzoneRole,
  resource,
  UserStatus,
  role,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function createTokenDecoder(
  httpClient: HttpClient,
): Dependencies["tokenDecoder"] {
  return {
    decodeToken(token: string): Promise<Account> {
      return httpClient
        .sendHttpRequest<{
          attributes: {
            email: string;
            firstName: string;
            lastName: string;
            uuid: Id;
            planzoneUuid: Id;
            token: string;
          };
        }>({
          baseUrl: "/cas",
          endpoint: "/oidc/profile",
          method: HttpMethods.GET,
        })
        .then(({ attributes }) => ({
          ...attributes,
          planzone: {
            ...planzone,
            uuid: attributes.planzoneUuid,
          },
          userAccount: {
            name: "John Doe",
            user: { smallPicture: "https://picsum.photos/30/30" },
            status: UserStatus.ACTIVE,
            planzoneRole: {
              uuid: PlanzoneRole.ADMINISTRATOR,
              ...role,
            },
          },
          preferences: attributes,
          resource: { ...resource, uuid: "" },
        }));
    },
  };
}

export { createTokenDecoder };
